<template>
    <v-container fluid>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div class="intro-container">
            <h3 class="texto">Seguimiento</h3>
            <span class="texto intro-subtext">
                Aquí podrás visualizar el estatus de las ordenes de trabajo y de
                los mecánicos, realizando un seguimiento.
            </span>
        </div>

        <v-row class="mt-1">
            <!-- Work Orders List -->
            <v-col cols="12" md="6">
                <v-card class="fill-height">
                    <v-card-title>
                        <p>Órdenes de Trabajo</p>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="workOrderSearch" append-icon="mdi-magnify" label="Buscar por folio"
                            single-line hide-details outlined dense class="search-field" type="number"></v-text-field>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-row class="ma-0 pa-1">
                            <v-col cols="12" sm="4">
                                <!-- <v-select v-model="workOrderEquipmentFilter" :items="equipmentOptions"
                                    label="Filtrar por equipo" dense outlined hide-details class="mb-1"
                                    clearable></v-select> -->

                                <v-autocomplete v-model="workOrderEquipmentFilter" :items="equipmentOptions"
                                    item-text="name" item-value="name" label="Filtrar por equipo" dense outlined
                                    hide-details class="mb-1" clearable no-data-text="No se encontraron equipos"
                                    :search-input.sync="equipmentSearchInput" placeholder="Escriba para buscar...">
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <!-- <v-list-item-title>{{ item }}</v-list-item-title> -->
                                            <v-list-item-subtitle v-if="item">{{ item }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition"
                                    offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="workOrderDateFilterText" label="Filtrar por fechas"
                                            readonly v-bind="attrs" v-on="on" dense outlined hide-details class="mb-1"
                                            clearable @click:clear="clearDateFilter"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="workOrderDateFilter" range no-title
                                        @change="updateDateFilter"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-btn outlined color="primary" @click="clearAllFilters" class="mb-1">
                                    <v-icon center>mdi-delete-sweep</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        <div v-if="loadingOT" class="pa-4">
                            <v-skeleton-loader type="list-item-avatar, list-item-two-line" v-for="n in 5" :key="n"
                                class="mb-2" />
                        </div>
                        <v-list v-else class="order-list overflow-y-auto">
                            <v-list-item-group>
                                <template v-for="(order, index) in filteredWorkOrders">
                                    <v-list-item :key="index">
                                        <v-list-item-avatar>
                                            <v-avatar :color="'#81a5fe'" size="40">
                                                <span class="white--text">{{ order.id }}</span>
                                            </v-avatar>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ order.title }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                Equipo: {{ order.equipment }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-list-item-subtitle>
                                                <v-chip x-small class="mr-2">
                                                    {{ formatDate(order.createdAt) }}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider v-if="index < filteredWorkOrders.length - 1"
                                        :key="`divider-${order.id}`"></v-divider>
                                </template>
                                <!-- <v-list-item v-if="filteredWorkOrders.length === 0">
                                    <v-list-item-content>
                                        <v-list-item-title class="text-center">
                                            No se encontraron órdenes de trabajo
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item> -->
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Mechanics List -->
            <v-col cols="12" md="6">
                <v-card class="fill-height">
                    <v-card-title>
                        <p>Mecánicos Disponibles</p>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="mechanicSearch" append-icon="mdi-magnify" label="Buscar por nombre"
                            single-line hide-details outlined dense class="search-field"></v-text-field>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-row class="ma-0 pa-1">
                            <v-col cols="12" sm="6">
                                <v-select v-model="mechanicSpecialtyFilter" :items="specialtyOptions"
                                    label="Filtrar por categoría" dense outlined hide-details class="mb-1"
                                    clearable></v-select>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-list class="mechanics-list overflow-y-auto">
                            <v-list-item-group>
                                <template v-for="(mechanic, index) in filteredMechanics">
                                    <v-list-item :key="index">
                                        <v-list-item-avatar>
                                            <v-avatar color="grey" size="40">
                                                <v-icon dark>mdi-account</v-icon>
                                            </v-avatar>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ mechanic.name }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                Especialidad: {{ mechanic.specialty }}
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle>
                                                <v-chip x-small :color="getMechanicStatusColor(mechanic.status)"
                                                    text-color="white">
                                                    {{ mechanic.status }}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-badge :content="mechanic.workload"
                                                :color="getWorkloadColor(mechanic.workload)" offset-x="10"
                                                offset-y="10">
                                                <v-btn icon>
                                                    <v-icon>mdi-account-details</v-icon>
                                                </v-btn>
                                            </v-badge>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider v-if="index < filteredMechanics.length - 1"
                                        :key="`divider-${mechanic.id}`"></v-divider>
                                </template>
                                <v-list-item v-if="filteredMechanics.length === 0">
                                    <v-list-item-content>
                                        <v-list-item-title class="text-center">
                                            No se encontraron mecánicos disponibles
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import MttoApi from "../../api/Mtto";
import Activos from "../../api/Catalogo";

dayjs.extend(isBetween)
dayjs.locale('es')

export default {
    data() {
        return {
            loading: false,
            loadingOT: false,
            // Work Orders
            workOrders: [],
            workOrderSearch: '',
            workOrderEquipmentFilter: null,
            workOrderDateFilter: [], // Array para el date picker en modo range
            workOrderDateFilterText: '',
            menuDate: false,
            equipmentOptions: ['Todos'],
            equipmentSearchInput: '', // Nueva variable para el autocomplete

            // Mechanics
            mechanics: [],
            mechanicSearch: '',
            mechanicStatusFilter: null,
            mechanicSpecialtyFilter: null,
            mechanicStatusOptions: ['Todos', 'Disponible', 'Ocupado', 'Ausente'],
            specialtyOptions: ['Todas', 'Motor', 'Eléctrico', 'Frenos', 'Transmisión', 'General'],
        };
    },

    computed: {
        filteredWorkOrders() {
            let filtered = [...this.workOrders];

            // 1. Filtro por folio (ID)
            if (this.workOrderSearch && this.workOrderSearch.toString().trim()) {
                const search = this.workOrderSearch.toString().trim();
                filtered = filtered.filter(order =>
                    order.id.toString().includes(search)
                );
            }

            // 2. Filtro por equipo
            if (this.workOrderEquipmentFilter && this.workOrderEquipmentFilter !== 'Todos') {
                filtered = filtered.filter(order =>
                    order.equipment === this.workOrderEquipmentFilter
                );
            }

            // 3. Filtro por rango de fechas
            if (this.workOrderDateFilter && this.workOrderDateFilter.length === 2) {
                const [startDate, endDate] = this.workOrderDateFilter.sort();
                const start = dayjs(startDate).startOf('day');
                const end = dayjs(endDate).endOf('day');

                filtered = filtered.filter(order => {
                    const orderDate = dayjs(order.createdAt);
                    return orderDate.isBetween(start, end, null, '[]');
                });
            }

            return filtered;
        },

        filteredMechanics() {
            let filtered = [...this.mechanics];

            // Filtro por búsqueda de texto
            if (this.mechanicSearch && this.mechanicSearch.trim()) {
                const search = this.mechanicSearch.toLowerCase().trim();
                filtered = filtered.filter(mechanic =>
                    mechanic.name.toLowerCase().includes(search) ||
                    mechanic.specialty.toLowerCase().includes(search)
                );
            }

            // Filtro por estado
            if (this.mechanicStatusFilter && this.mechanicStatusFilter !== 'Todos') {
                filtered = filtered.filter(mechanic =>
                    mechanic.status === this.mechanicStatusFilter
                );
            }

            // Filtro por especialidad
            if (this.mechanicSpecialtyFilter && this.mechanicSpecialtyFilter !== 'Todas') {
                filtered = filtered.filter(mechanic =>
                    mechanic.specialty === this.mechanicSpecialtyFilter
                );
            }

            return filtered;
        }
    },

    methods: {
        updateDateFilter() {
            if (this.workOrderDateFilter && this.workOrderDateFilter.length === 2) {
                const [start, end] = this.workOrderDateFilter.sort();
                this.workOrderDateFilterText = `${dayjs(start).format('DD/MM/YYYY')} - ${dayjs(end).format('DD/MM/YYYY')}`;
            } else {
                this.workOrderDateFilterText = '';
            }
            this.menuDate = false;
        },

        clearDateFilter() {
            this.workOrderDateFilter = [];
            this.workOrderDateFilterText = '';
        },

        clearAllFilters() {
            this.workOrderSearch = '';
            this.workOrderEquipmentFilter = null;
            this.clearDateFilter();
        },

        formatDate(dateString) {
            return dayjs(dateString).format('dddd, D MMMM YYYY HH:mm');
        },

        async fetchData() {
            // this.loading = true;
            try {
                this.loadingOT = true
                // await Activos.listEquipments().then((e) => {
                //     this.equipmentOptions.push(e)
                // })
                await MttoApi.listOTPending().then((e) => {
                    this.workOrders = e.data.data
                }).catch(() => this.loadingOT = false)
                this.loadingOT = false

                this.mechanics = [
                    { id: 1, name: 'Miguel Hernández', specialty: 'Motor', status: 'Disponible', workload: 0 },
                    { id: 2, name: 'José Rodríguez', specialty: 'Eléctrico', status: 'Ocupado', workload: 2 },
                    { id: 3, name: 'Fernando García', specialty: 'Frenos', status: 'Disponible', workload: 1 },
                    { id: 4, name: 'Alejandro Díaz', specialty: 'Transmisión', status: 'Ausente', workload: 0 },
                    { id: 5, name: 'Ricardo Morales', specialty: 'General', status: 'Disponible', workload: 3 },
                    { id: 6, name: 'Eduardo Vargas', specialty: 'Motor', status: 'Ocupado', workload: 4 },
                ];
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },

        getStatusColor(status) {
            switch (status) {
                case 'Pendiente': return 'orange';
                case 'En progreso': return 'blue';
                case 'Completada': return 'green';
                case 'Cancelada': return 'red';
                default: return 'grey';
            }
        },

        getPriorityColor(priority) {
            switch (priority) {
                case 'Alta': return 'red';
                case 'Media': return 'orange';
                case 'Baja': return 'green';
                default: return 'grey';
            }
        },

        getMechanicStatusColor(status) {
            switch (status) {
                case 'Disponible': return 'green';
                case 'Ocupado': return 'orange';
                case 'Ausente': return 'grey';
                default: return 'grey';
            }
        },

        getWorkloadColor(workload) {
            if (workload === 0) return 'green';
            if (workload <= 2) return 'orange';
            return 'red';
        },
        async getEquipment() {
            try {
                this.loading = true
                await Activos.listEquipments()
                    .then((e) => {
                        console.log(e.data.data)
                        this.equipmentOptions.push(...e.data.data)
                    })
            } catch (error) {
                console.log(error)
            }
        }
    },

    mounted() {
        this.fetchData();
        this.getEquipment();
    }
};
</script>

<style scoped>
.intro-container {
  margin-top: 64px;
  margin-left: 8px;
}

.intro-subtext {
  font-size: 12px;
  color: #4a5568;
}

.order-list,
.mechanics-list {
  max-height: 400px;
}

.search-field {
  max-width: 200px;
}

/* Responsive */
@media (max-width: 600px) {
  .intro-container { margin-top: 32px; margin-left: 4px; }
  .intro-subtext { font-size: 10px; }
  .order-list, .mechanics-list { max-height: 300px; }
  .search-field { max-width: 150px; }
}

@media (min-width: 1200px) {
  .intro-container { margin-top: 60px; margin-left: 8px; }
  .order-list, .mechanics-list { max-height: 400px; }
}

@media (min-width: 1600px) {
  .order-list, .mechanics-list { max-height: 500px; }
}
</style>